import React, { useCallback } from 'react'
import styled from '@emotion/styled'

import { Trash2 } from 'react-feather'
import Table, { TableRow, TableCell } from 'Components/Table'
import { colors } from 'Constants'

import { toast } from 'react-toastify'
import { toastWithErrorMessage } from 'Helpers/toast'
import CustomLinkService from 'Services/customlinks'
import { createModal } from 'Components/Modal'
import { EditLinkModal } from './EditLinkModal'
import { DeleteLinkModal } from './DeleteLinkModal'

const TableRowClickableStyle = styled(TableRow)`
  cursor: pointer;
  > * {
    transition: 0.2s background-color;
  }
  :hover {
    > * {
      background-color: ${colors.background900};
    }
  }
`

const TableRowClickable = ({ data, ...props }) => (
  <TableRowClickableStyle
    onClick={async () => {
      const { id } = data
      const { updateLinks, customLinks } = props

      await CustomLinkService.getLink({ id })
        .then(resp => {
          const link = resp.data
          // Link we got
          createModal(
            <EditLinkModal customLink={link} updateLinks={updateLinks} customLinks={customLinks} />
          )
        })
        .catch(error => {
          toastWithErrorMessage(error.message)
        })
    }}
    data={data}
    {...props}
  />
)

const columns = [
  {
    header: 'ID',
    accessor: 'id',
    size: '0.15x'
  },
  {
    header: 'Icon',
    accessor: 'icon'
  },
  {
    header: 'Name',
    accessor: 'shortName'
  },
  {
    header: 'Description',
    accessor: 'longName'
  },
  {
    header: 'Link',
    accessor: 'url'
  }
]

export const CustomLinkTable = ({ customLinks, updateLinks }) => {
  const DeleteCell = useCallback(
    ({ data }) => (
      <TableCell
        xAlign
        onClick={e => {
          e.stopPropagation()

          const selectedLink = customLinks.find(link => link.id === data.id)
          if (!selectedLink) return toast.error('Failed to find custom link to delete')

          createModal(
            <DeleteLinkModal
              customLink={selectedLink}
              updateLinks={updateLinks}
              customLinks={customLinks}
            />
          )
        }}
      >
        <Trash2 />
      </TableCell>
    ),
    [customLinks]
  )

  const columnsWithDelete = [
    ...columns,
    { header: 'Delete', size: '0.2x', accessor: 'delete', Cell: DeleteCell }
  ]

  return (
    <Table
      columns={columnsWithDelete}
      data={customLinks}
      Row={TableRowClickable}
      updateLinks={updateLinks}
    />
  )
}
